import React, { useState } from "react";
import { getOneProduct } from "../../../middlewares/sysNavigation/SysNavigation";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { codeOk } from "../../../middlewares";
import { GoBack } from "../../home/component/GoBackUtils";
import { MyMessage } from "../../home/component/messageUtils";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { Title } from "../../home/component/TitleUtils";
import { InputField, Select, TextArea } from "../../home/component/FormUtils";
import { MyActionButton } from "../../home/component/ActionButtonUtils";
import { useGeoPositionContext } from "../utils/geoPosition";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { DashboardIntro } from "../../home/component/DashboardIntroUtils";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import { MyButton } from "../../home/component/ButtonUtils";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const product = getOneProduct();
  const [thumbnail, setThumbnail] = useState(product?.images_url);
  const [thumbnailId, setThumbnailId] = useState(product?.images_cdn_ids);
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const product_id = product?.product_id;
  const [title, setTitle] = useState(product?.name);
  const [category, setCategory] = useState(product?.category);
  const [quantity, setQuantity] = useState(product?.quantity);
  const [productStatus, setProductStatus] = useState(product?.status);
  const [description, setDescription] = useState(product?.description);
  const [pricing, setPricing] = useState(product?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const productRoutes = "/data/product";

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneProductHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      name: title,
      category: category,
      quantity: quantity,
      images_url: thumbnail ? thumbnail : defaultImage,
      images_cdn_ids: thumbnailId ? thumbnailId : "",
      description: description,
      status: productStatus,
      created_by: product?.managed_by,
      pricing: pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: product_id,
      data: data,
      content: _TYPES_.PRODUCT,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  return (
    <div className="p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <BreadCrumbComponent />
      <GoBack props={{ route: productRoutes }} />

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}

      <div className="my-5">
        <DashboardIntro props={{ intro: `Edit Product`, name: entry_label }} />
      </div>
      <form onSubmit={updateOneProductHandler}>
        <div className="mt-8 flex flex-col items-center justify-center font-medium text-sm md:text-base">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />

          <ImageKitUpload
            thumbnail={thumbnail}
            thumbnailId={thumbnailId}
            setThumbnail={setThumbnail}
            setThumbnailId={setThumbnailId}
            folder={image_kit_folder(country_name, FOLDERS.PROCUCTS)}
          />

          <Title props={{ title: "Product Details" }} />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
            <InputField
              props={{
                id: "title",
                title: "Title",
                type: "text",
                value: title ? title : "",
                onChange: (e) => {
                  setTitle(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />

            <Select
              props={{
                id: "category",
                title: "Category",
                option: [
                  "Men",
                  "Women",
                  "Teen",
                  "Kids",
                  "African shirts",
                  "African pants",
                  "Beads",
                  "Carvings",
                  "Handbags",
                ],
                preselect: category ? [{ name: category }] : null,
                onChange: (e) => {
                  setCategory(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />

            <InputField
              props={{
                id: "quantity",
                title: "Quantity",
                type: "number",
                value: quantity ? quantity : "",
                onChange: (e) => {
                  setQuantity(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>

          <Title props={{ title: "Pricing" }} />

          <Pricing pricing={pricing} setPricing={setPricing} />

          <Title props={{ title: "More Settings" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
            <Select
              props={{
                id: "product_status",
                title: "Status",
                option: ["visible", "invisible"],
                preselect:
                  productStatus !== null
                    ? [
                        {
                          name: productStatus === 1 ? "visible" : "invisible",
                        },
                      ]
                    : null,
                onChange: (e) => {
                  if (e.target.selectedIndex === 0) setProductStatus(1);
                  else setProductStatus(0);

                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>

          <div className=" w-full pt-8">
            <MyButton
              onClick={() => setShowDescriptionModal(true)}
              className="bg-blue-700 py-3"
            >
              Generate Description
            </MyButton>
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                value: description ? description : "",
                onChange: (e) => {
                  setDescription(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>

          <MyActionButton
            loading={loading}
            title="Save Changes"
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage(null);
            }}
          />
        </div>
      </form>
    </div>
  );
};

export default Edit;
